import WithdrawalModalComponent from './withdrawal-modal.component'

const WithdrawalModalModule = angular.module('cdbl.withdrawal-modal', [

])
  .component('cdblWithdrawalModal', WithdrawalModalComponent)
  .name

export default WithdrawalModalModule
